var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('MyInfoWebpart'),_c('MyCountWebpart',{attrs:{"isMailUser":_vm.isMailUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }